import firebase from 'firebase/app'
import 'firebase/auth' // If you need it
import 'firebase/firestore' // If you need it
import 'firebase/storage' // If you need it
import 'firebase/analytics' // If you need it
import 'firebase/performance' // If you need it

const clientCredentials = {

  apiKey: "AIzaSyBS9QGlpihzZ-zLz1I6xZngQQLdRkzHs7g",
  authDomain: "kuvashose.firebaseapp.com",
  databaseURL: "https://kuvashose.firebaseio.com",
  projectId: "kuvashose",
  storageBucket: "kuvashose.appspot.com",
  messagingSenderId: "891118479292",
  appId: "1:891118479292:web:634135080ec876bc",
  measurementId: "G-RTKYGRZVYK"

}

if (!firebase.apps.length) {
  firebase.initializeApp(clientCredentials)
  // Check that `window` is in scope for the analytics module!
  if (typeof window !== 'undefined') {
    // Enable analytics. https://firebase.google.com/docs/analytics/get-started
    if ('measurementId' in clientCredentials) {
      firebase.analytics()
      firebase.performance()
    }
  }
  firebase.auth().signInAnonymously()
    .then(() => {
      // console.log('anonimusly sign in')
    })
    .catch((error) => {

      console.log(error.message)
    });
}

export default firebase

